/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TextInput, View } from "react-native";

import { Button, Text, styles } from "UpduoLibrary";
import {
  skaleDisabledButtonTextGray,
  skaleBlack,
  skaleWhite,
} from "config/UpduoColors";
import UpduoLogo from "assets/upduo-black.svg";
import useOrgRoute from "./useOrgRoute";

const textColor = skaleDisabledButtonTextGray;

export default function JoinOrganizationRoute({ history }) {
  const {
    submitButtonText,
    submitButtonDisabled,
    orgCode,
    setOrgCode,
    orgCodeValidationText,
    setOrgCodeValidationText,
    _handleButtonPress,
  } = useOrgRoute(history);

  return (
    <View
      style={{
        flex: 1,
        height: "100vh",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: skaleWhite,
      }}
    >
      <View
        style={{
          marginHorizontal: "10%",
          marginTop: 40,
          marginBottom: 15,
          alignItems: "center",
          maxWidth: 500,
        }}
      >
        <Text
          isHeading={true}
          style={{
            color: skaleBlack,
            fontSize: 24,
            marginBottom: 15,
          }}
        >
          {"Do you have a community code?"}
        </Text>
        <Text
          style={{
            color: textColor,
            fontSize: 16,
            marginBottom: 55,
            textAlign: "center",
          }}
        >
          {
            "A community code is provided by your\norganization or event host in order for you to\njoin your community."
          }
        </Text>
        <TextInput
          value={orgCode}
          placeholder={"Community Code"}
          autoCapitalize={"none"}
          autoFocus={true}
          style={styles.textInput}
          onChangeText={(text: string) => {
            setOrgCodeValidationText("");
            setOrgCode(text);
          }}
        />
        {orgCodeValidationText ? (
          <View
            style={{
              marginTop: "3vh",
              paddingHorizontal: 30,
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              maxHeight: "30vh",
            }}
          >
            <View
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: 20,
                  color: skaleBlack,
                }}
              >
                {orgCodeValidationText}
              </Text>
              <Text
                style={{
                  fontSize: 16,
                  color: skaleBlack,
                  textAlign: "center",
                }}
              >
                {"Please try again."}
              </Text>
            </View>
          </View>
        ) : null}
      </View>
      <View style={{ marginVertical: 20 }}>
        <Button
          disabled={submitButtonDisabled}
          onPress={_handleButtonPress}
          text={submitButtonText}
        />
      </View>
      <View style={{ position: "absolute", top: 90, alignItems: "center" }}>
        <img src={UpduoLogo} style={{ width: 117 }} alt={"logo"} />
      </View>
    </View>
  );
}
